<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">{{ location }}</h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.inventory.stocks.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.inventory.stocks.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box dark color="outline" class="col-6 col-md-auto p-1">
          <bx-value
            :label="$t('lang.inventory.stocks.box_label_1')"
            :value="number_of_gtin"
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-auto p-1">
          <bx-value
            :label="$t('lang.inventory.stocks.box_label_2')"
            :value="number_of_stock"
            font-size="xs"
            valueColor="red"
          />
        </bx-box>
      </div>
      <skeleton-boxes :boxes="2" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <v-row class="d-flex d-sm-none">
          <v-list width="100%">
            <v-list-item
              two-line
              v-for="(item, index) in data"
              :key="index"
              class="green lighten-5 ma-2 rounded-lg"
              ripple
            >
              <v-list-item-content>
                <v-list-item-title>
                  <div>
                    {{ item.gtin }}
                  </div>
                </v-list-item-title>
                <v-list-item-subtitle>{{ item.section }}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">{{
                  item.cloth_type
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-subtitle class="text-caption">
                  Quantity: {{ item.quantity }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">
                  {{ item.color }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">
                  {{ item.model }}
                </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              v-model.lazy="areaSelected"
              :items="areaList"
              color="#9ac31c"
              :label="$t('lang.admin.device_form.label_select_location')"
              item-color="#9ac31c"
              item-text="description"
              item-value="id"
              outlined
            >
            </v-select>
          </v-col>
          <v-col class="d-flex justify-content-center" md="auto">
            <v-btn
              color="#9ac31c"
              class="px-10"
              style="height: 55px"
              @click="submit"
              :loading="shouldLoading"
              :disabled="shouldLoading"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
        <div class="row">
          <div class="col-12">
            <bx-box
              :title="
                ordersCount + ' ' + $t('lang.inventory.stocks.table_title')
              "
              no-padding
              :loading="shouldLoading"
            >
              <skeleton-table :columns="7" v-if="shouldLoading" />

              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                backendPagination
                :currentPage="page"
                :perPage="itemsPerPage"
                :total="ordersCount"
                @search="onSearch"
                highlight-danger="quantity"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column field="danger" centered>
                    <img
                      v-if="props.row.quantity === 0"
                      src="@/assets/i/triangle-outline.svg"
                      style="height: 20px; width: 20px;"
                    />
                  </bx-table-column>
                  <bx-table-column field="gtin" centered>
                    <router-link
                      :to="{
                        name: 'inventory-gtin',
                        params: { gtin: props.row.gtin }
                      }"
                      class="bx-link bx-link-bold"
                    >
                      {{ props.row.gtin }}
                    </router-link>
                  </bx-table-column>
                  <bx-table-column centered>{{
                    props.row.quantity
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.cloth_type
                  }}</bx-table-column>
                  <bx-table-column field="section">{{
                    props.row.section
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.model
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.colour
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.season
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.description
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.price
                  }}</bx-table-column>
                </template>
              </bx-table>
            </bx-box>
            <v-snackbar
              :color="snackbarColor"
              v-model="snackbar"
              timeout="5000"
              top
              right
            >
              {{ snackbarText }}
            </v-snackbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "inbound-dashboard",
  data() {
    return {
      shouldLoading: true,
      reloadInterval: null,
      number_of_gtin: 0,
      number_of_stock: 0,
      columns: [],
      data: [],
      key: "inventory_stocks",
      filters: [],
      pending: 12,
      completed: 34,
      total: 46,
      page: 1,
      ordersCount: 0,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      areaList: [],
      areaSelected: [],
      snackbar: false,
      snackbarText: "",
      snackbarColor: "#9ac31c"
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    }
  },
  methods: {
    onSearch(field, value) {
      this.$session.set(this.key + field, value);
      this.filters[field] = value;
      this.getData();
    },
    updatePage(p) {
      this.page = p;
      this.submit();
      // this.data = []
    },
    async getData() {
      try {
        let location = localStorage.getItem("location");
        let locationId = localStorage.getItem("location_id");
        if (!location || !locationId) {
          try {
            let firstLocation = await this.$api.location.search("", {
              limit: 1,
              offset: 0,
              orderBy: "id"
            });
            location = firstLocation.results[0].description;
            locationId = firstLocation.results[0].id;
          } catch (error) {
            console.log(error);
          }
        }
        this.areaList = await this.$api.area.locationAreaList(locationId);
        console.log(this.areaList);
        let area = await this.$api.location.listAreas({
          limit: 1
        });
        if (!area.data.results[0]) return;
        this.columns = [
          {
            field: "danger",
            width: "10",
            centered: true
          },
          {
            field: "gtin",
            label: this.$t("lang.inventory.stocks.table_field_1"),
            width: "120",
            centered: true,
            filter: {
              placeholder: this.$t("lang.inventory.stocks.table_field_1"),
              value: this.filters.gtin
            }
          },
          {
            field: "quantity",
            label: this.$t("lang.inventory.stocks.table_field_2"),
            width: "120",
            centered: true
          },
          {
            field: "cloth_type",
            label: this.$t("lang.inventory.stocks.table_field_4"),
            centered: true
          },
          {
            field: "section",
            label: this.$t("lang.inventory.stocks.table_field_3")
          },
          {
            field: "model",
            label: this.$t("lang.inventory.stocks.table_field_5"),
            centered: true
          },
          {
            field: "color",
            label: this.$t("lang.inventory.stocks.table_field_6"),
            centered: true
          },
          {
            field: "season",
            label: this.$t("lang.inventory.stocks.season"),
            centered: true
          },
          {
            field: "description",
            label: this.$t("lang.inventory.stocks.table_field_8"),
            centered: true
          },
          {
            field: "price",
            label: this.$t("lang.inventory.stocks.price"),
            centered: true
          },
        ];
      } catch (error) {
        console.log(error);
      } finally {
        this.shouldLoading = false;
      }
    },
    async submit() {
      this.shouldLoading = true;
      const inventories = await this.$api.area.global_summary(this.areaSelected, {
        offset: (this.page - 1) * this.itemsPerPage,
        limit: this.itemsPerPage,
        gtin__contains: this.filters.gtin
      });
      if (inventories.results.length) {
        let selected = this.areaList.find(x => x.id === this.areaSelected);
        this.number_of_stock = selected.stock;
        this.number_of_gtin = inventories.count;
        this.ordersCount = inventories.count;
        this.data = inventories.results.map(item => {
          return {
            id: item.id,
            gtin: item.gtin,
            quantity: item.quantity,
            color: item.colour,
            model: item.model,
            section: item.section,
            cloth_type: item.cloth_type,
            size: item.size,
            season: item.season,
            description: item.description,
            size_primary: item.size_primary,
            size_secondary: item.size_secondary,
            zone_primary: item.zone_primary,
            zone_secondary: item.zone_secondary,
            item_type_area_minimum_stock: item.item_type_area_minimum_stock,
            price: item.price,
            minimum_stock: item.minimum_stock
          };
        });
      } else {
        this.number_of_stock = 0;
        this.ordersCount = inventories.count;
        this.number_of_gtin = 0;
        this.data = [];
        this.snackbarText = "No results found";
        this.snackbarColor = "red darken-2";
        this.snackbar = true;
      }
      this.shouldLoading = false;
    }
  },
  async mounted() {
    // this.reloadInterval = setInterval(
    //   this.getData,
    //   process.env.VUE_APP_RELOAD_TIME
    // )
    this.getData();
    this.filters.gtin = this.$session.get(this.key + "gtin");
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
</script>
